import { Flex, Text, Box, useColorModeValue } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import environment from "src/utils/environment";
import { isFreemium } from "src/modules/auth/duck/selectors";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as LockIcon } from "src/icons/lock.svg";

const Category = ({ isActive, onClick, children, color }) => (
  <Text
    onClick={onClick}
    py="5px"
    px="8px"
    mr="8px"
    fontSize="12px"
    lineHeight="14px"
    letterSpacing="0.14px"
    color={isActive ? color : "mediumEmphasis"}
    bg={isActive ? "primaryLight" : "transparent"}
    borderRadius="12px"
    transition="all 0.3s"
    _hover={{
      color: "primary"
    }}
  >
    {children}
  </Text>
);

export default function CategorySelect({
  selectedCategory,
  categories,
  onSelect,
  t,
  ...rest
}) {
  const borderColor = useColorModeValue(
    "rgba(0, 0, 0, 0.12)",
    "rgba(255, 255, 255, 0.12)"
  );
  const { isBibino } = environment;
  const isFreeVersion = useSelector(isFreemium);
  return (
    <Flex
      pb="5px"
      width="100%"
      borderBottom="1px solid"
      borderColor={borderColor}
      {...rest}
    >
      {categories.map(([name, key]) => {
        const lockedFeatures = ["Face", "Dress", "Accessories"];
        const lock = lockedFeatures.includes(name) && isFreeVersion && isBibino;
        return (
          <Box key={key} position="relative">
            {lock && (
              <Box position="absolute" top="-3px" right="0">
                <SvgContainer icon={LockIcon} fill="lowEmphasis" size="14px" />
              </Box>
            )}
            <Category
              color={isBibino ? "#8f6df5" : "#58a509"}
              onClick={() => onSelect(key)}
              isActive={key === selectedCategory}
            >
              {t(`avatar.category.${name.toLowerCase()}`)}
            </Category>
          </Box>
        );
      })}
    </Flex>
  );
}
